export default __webpack_public_path__ + "static/media/chFaq.95f029a2.pdf";